var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{attrs:{"id":"myChart"}}),(_vm.chart)?_c('div',{staticClass:"labels",domProps:{"innerHTML":_vm._s(_vm.chart.generateLegend())}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }